export default __webpack_public_path__ + "static/media/apigee.9e2bcf38.svg";